// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

const ResultsList = ({ children, noResultsMessage = '' }) => {
    const total = children ? React.Children.toArray(children).length : 0;
    return (
        <Fragment>
            {total > 0 ? (
                <ul className="list-group list-group-flush">
                    {React.Children.map(children, (child, index) => (
                        <li key={index} className="list-group-item">
                            {child}
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="pb-3">{noResultsMessage}</div>
            )}
        </Fragment>
    );
};

ResultsList.propTypes = {
    children: PropTypes.node,
    noResultsMessage: PropTypes.string,
};

export default ResultsList;
